import * as React from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import images from "../../../global-styles/images";
import { Tooltip } from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";

const Tile = (props: any) => {
  const { image, label, tooltipText, count } = props;

  return (
    <Grid item xs={12} sm={12} md={12} lg={2.4} xl={2.4} flexGrow={1}>
      <Paper
        sx={{
          p: "13px 0px 10px 16px",
          // pt: 3,
          margin: "auto",
          height: "100%",
          flexGrow: 1,
          backgroundColor: (theme) =>
            theme.palette.mode === "dark" ? "#1A2027" : "#fff",
          boxShadow: "none",
          border: "1px solid #ccc",
          borderRadius: "8px",
          position: "relative",
          display: "flex",
        }}
      >
        <Grid
          sx={{
            flexGrow: 1,
            // pr: "40px",
            // pt: "20px",
          }}
        >
          <Typography
            sx={{
              color: "#727272",
              fontSize: "12px",
              display: "flex",
            }}
            variant="body2"
          >
            {label}&nbsp;
            <Tooltip title={tooltipText} placement="top">
              <HelpIcon
                sx={{ mt: 0.3, fontSize: 13 }}
                onClick={(e: any) => {
                  e.stopPropagation();
                }}
              />
            </Tooltip>
          </Typography>
          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: "26px",
            }}
            variant="body2"
          >
            {count}
          </Typography>
        </Grid>
        <Typography
          variant="subtitle1"
          component="div"
          sx={{
            padding: "0 7px 0px 0px",
            // position: "absolute",
            // right: "16px",
            // top: "16px",
          }}
        >
          <img className="fbmetrictilesvg" src={image} />
        </Typography>
      </Paper>
    </Grid>
  );
};

const ChatMetricsTileCount = (props: any) => {
  const { ReportsTicketsTotalCountsData, ReportsTicketsRaisedData } = props;

  const formatNumber = (num: any) => {
    if (num >= 1e9) {
      return (num / 1e9).toFixed(1) + "B";
      // eslint-disable-next-line @typescript-eslint/tslint/config
    } else if (num >= 1e6) {
      return (num / 1e6).toFixed(1) + "M";
      // eslint-disable-next-line @typescript-eslint/tslint/config
    } else if (num >= 1e3) {
      return (num / 1e3).toFixed(1) + "K";
      // eslint-disable-next-line @typescript-eslint/tslint/config
    } else {
      return num.toString();
    }
  };
  return (
    <>
      <Tile
        image={images.noofsession}
        label="Number of sessions"
        tooltipText="Number of times users initiated a chat session"
        count={formatNumber(ReportsTicketsTotalCountsData.sessionIdCount || 0)}
      />
      <Tile
        image={images.totalnomsg}
        label="Total messages"
        tooltipText="Number of messages posted to the chatbot"
        count={formatNumber(
          ReportsTicketsTotalCountsData.totalMessageCount || 0
        )}
      />
      <Tile
        image={images.botresolved}
        label="Bot resolved"
        tooltipText="Number of times chatbot responded without redirecting user to open a ticket"
        count={formatNumber(
          ReportsTicketsTotalCountsData.botAnsweredCount || 0
        )}
      />
      <Tile
        image={images.promptoraistkt}
        label="Prompted to raise ticket"
        tooltipText="Number of times the chatbot suggested raising a ticket"
        count={formatNumber(
          ReportsTicketsTotalCountsData.promptToRaiseTicketCount || 0
        )}
      />
      <Tile
        image={images.noofticktraised}
        label="Tickets raised"
        tooltipText="Number of tickets opened by users when prompted by the chatbot"
        count={formatNumber(ReportsTicketsRaisedData?.chartData?.total || 0)}
      />
    </>
  );
};

export default ChatMetricsTileCount;
